import React from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { localization } from "../../service/languages/languages";

export default function Error404() {
  const navigate = useNavigate();
  return (
    <Container className="fw-bold fontLight  d-flex flex-column justify-content-center error404">
      <div className="d-flex flex-column gap-3 align-items-center">
        <div
          className="d-flex gap-2 align-items-center"
          style={{ fontSize: "120px" }}
        >
          4{emoji}4
        </div>
        <div style={{ fontSize: "40px", marginTop: "-60px" }}>
          {localization["NOT FOUND"]}
        </div>
        <button
          onClick={() => navigate(-1)}
          className="border-r3 ps-5 pe-5 p-2"
        >
          {localization["Go back"]}
        </button>
      </div>
    </Container>
  );
}

const emoji = (
  <svg
    width="90"
    height="90"
    viewBox="0 0 90 90"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M45 90C69.8528 90 90 69.8528 90 45C90 20.1472 69.8528 0 45 0C20.1472 0 0 20.1472 0 45C0 69.8528 20.1472 90 45 90Z"
      fill="#F2B349"
    />
    <path
      d="M68.5124 62.5398C68.5124 69.6435 57.3448 63.1466 45.372 63.1466C33.3993 63.1466 21.2894 69.3751 21.2894 62.2714C21.2894 58.2206 25.149 52.5872 30.6861 48.4957C34.8579 45.412 39.9808 43.2036 45.127 43.2036C50.419 43.2036 55.6032 45.5944 59.7385 48.8764C64.9576 53.0146 68.5124 58.5751 68.5124 62.5398Z"
      fill="#444053"
    />
    <path
      d="M59.737 48.8734C53.3729 47.9151 41.8625 46.7467 30.6862 48.4927C34.858 45.4091 39.9808 43.2007 45.127 43.2007C50.4176 43.2007 55.6017 45.5914 59.737 48.8734Z"
      fill="#F6F8FB"
    />
    <path
      d="M28.9022 34.0256C29.7584 33.9775 33.7887 33.6741 36.3487 32.214C36.7598 31.9721 37.2243 31.8353 37.7009 31.8157C38.5148 31.7924 39.4513 32.1323 38.8518 34.0344C37.8803 37.1457 32.2396 40.6465 28.7388 40.4525C25.3722 40.2658 21.3784 38.9093 18.7411 34.1394C18.4884 33.6805 18.3639 33.162 18.3808 32.6384C18.4114 31.6757 18.7615 30.4694 20.5688 31.8143C23.0106 33.6303 27.6433 33.9746 28.5725 34.0256C28.6823 34.0315 28.7924 34.0315 28.9022 34.0256Z"
      fill="#444053"
    />
    <path
      d="M61.2846 34.0256C62.1409 33.9775 66.1712 33.6741 68.7311 32.214C69.1423 31.9721 69.6067 31.8353 70.0833 31.8157C70.8973 31.7924 71.8337 32.1323 71.2342 34.0344C70.2627 37.1457 64.6221 40.6465 61.1213 40.4525C57.7546 40.2658 53.7608 38.9093 51.1235 34.1394C50.8708 33.6805 50.7464 33.162 50.7632 32.6384C50.7939 31.6757 51.1439 30.4694 52.9512 31.8143C55.393 33.6303 60.0258 33.9746 60.955 34.0256C61.0648 34.0315 61.1748 34.0315 61.2846 34.0256Z"
      fill="#444053"
    />
  </svg>
);
